import React from "react";

const SearchInfo = ({ searchBoxInfo }) => {
	return (
		<section className="search-info-box">
			<div className="search-info-box-info">
				<p className="grey-text">IP Address</p>
				<h2 className="heading">{searchBoxInfo.ip}</h2>
			</div>
			<div className="search-info-box-info">
				<p className="grey-text">Location</p>
				<h2 className="heading">{`${searchBoxInfo.location.region}, ${searchBoxInfo.location.country}`}</h2>
			</div>
			<div className="search-info-box-info">
				<p className="grey-text">Timezone</p>
				<h2 className="heading">{`UTC ${searchBoxInfo.location.timezone}`}</h2>
			</div>
			<div className="search-info-box-info-end">
				<p className="grey-text">ISP</p>
				<h2 className="heading">{searchBoxInfo.isp}</h2>
			</div>
		</section>
	);
};

export default SearchInfo;
